export default "__VITE_ASSET__be1def44__"